import axios from '@/http/axios/index.js'


export default {
    list: function (data) {
        return axios.get('repse/vendors', { params: data })
    },
    getStatusList:function(data){
        return axios.get('repse/vendors/statusList', data)   
    },
    changeActive:function(data){
        return axios.post('repse/vendors/changeActive', data )
    },
    getDocumentation: function (data,id) {
        return axios.get('repse/vendors/'+ id +'/documentation', { params: data })
    },
    getVendor: function (id) {
        return axios.get('repse/vendors/' + id)
    },
    createDocumentationRequest: function (data) {
        return axios.post('repse/createDocumentationRequest',data)
    },
    getRequests: function (data,id) {
        return axios.get('repse/documentation/'+ id +'/requests', { params: data })
    },
    getDocumentationDetails: function (id) {
        return axios.get('repse/documentation/'+ id +'/details')
    },
    uploadFile: function (data) {
        return axios.post('repse/files/upload', data, {
            headers: { 'Content-Type': 'multipart/form-data' },
            processData: false,
            contentType: false
          })
    },
    getFiles: function (data) {
        return axios.post('repse/files/get', data)
    },
    getRequestsStatus: function () {
        return axios.get('repse/requests/getStatus')
    },
    validateDocument: function (data) {
        return axios.post('repse/requests/validateDocument', data )
    },
    deleteRequest: function (payload) {
        return axios.get('repse/requests/delete',  { params: payload } )
    },

    
}